/* ZINKE — Formularschutz fuer alle E-Mail-Formulare, 29.09.2026 (Theme 9.3)
   ==========================================================================
   Anlass (Pascal, 29.09.2026, Clarity-Aufzeichnung 09:15, Samsung Internet):
   Ein Kunde aus der PMax-Anzeige wollte sich im Fussbereich fuer den
   Newsletter anmelden. 4x auf „Anmelden“ getippt, keine Anmeldung kam an.

   Gemessen am 29.09.2026 gegen die Live-Seite (Playwright, Handy-Masse):

   1. Die eigene Adresspruefung in zinke-nl-fest.js und zinke-newsletter.js
      hat NICHTS aufgehalten. Shopify haengt an jedes /contact-Formular ein
      Skript „form-persister“ (inline im Kopf). Es bindet sich bei
      DOMContentLoaded an das Formular, ruft selbst preventDefault() auf und
      schickt das Formular danach IMMER nativ ab — egal, ob ein anderes
      Skript das Absenden vorher abgebrochen hat. Unsere rote Meldung stand
      also kurz da, und im selben Moment ging die falsche Adresse trotzdem
      an Shopify.
   2. Shopify lehnt die Adresse ab und leitet zurueck auf dieselbe Seite mit
      ?contact[tags]=newsletter,fest-fuss&form_type=customer — ohne
      customer_posted=true. Genau diese URL steht in der Clarity-Aufzeichnung
      (04:40 und 05:21). Das Feld ist danach LEER, der Kunde muss alles neu
      tippen. Scheiterte die Fussanmeldung, oeffnete sich zusaetzlich das
      Pop-up mit „15 % auf alles“ und einer Fehlermeldung — waehrend der
      Fussbereich „5 %“ versprach. Scheiterte das Pop-up, kam gar keine
      Meldung.
   3. Die ersten drei Tipps (01:11, 02:23, 03:41) hat der Browser selbst
      abgewiesen (type=email). Diese Meldung ist eine Sprechblase des
      Browsers, die Clarity nicht aufzeichnet und die bei Samsung Internet
      je nach Version kaum zu sehen ist.

   Was dieses Skript tut:
   A) Es haengt sich in der CAPTURE-Phase an das document. Damit laeuft es
      VOR allen Listenern am Formular, auch vor Shopifys form-persister.
      Ist die Adresse ungueltig, wird das Absenden mit
      stopImmediatePropagation() komplett gestoppt — der Persister sieht das
      Ereignis nie.
   B) Es bereinigt vorher still: Leerzeichen raus, Komma in der Domain wird
      Punkt, Punkt am Ende weg, Domain klein, ＠ wird @.
   C) Es sagt konkret, was fehlt (kein @, keine Endung, Umlaut, Vertipper
      mit Vorschlag zum Antippen, Wegwerfadresse) — in 9 Sprachen.
   D) novalidate an allen betroffenen Formularen: Keine unsichtbare
      Browser-Sprechblase mehr, sondern unsere Meldung im Design. Ohne
      JavaScript bleibt die Browser-Pruefung bestehen.
   E) Rueckweg: Kommt die Seite mit form_type=… aber ohne *_posted=true
      zurueck, hat Shopify abgelehnt. Dann steht die Meldung im RICHTIGEN
      Formular (Fuss, Seite oder Pop-up), die getippte Adresse steht wieder
      im Feld, das Formular wird ins Bild geholt und die URL bereinigt.
   F) Tastatur offen (Handy): feste Leisten unten (Newsletter-Leiste,
      Cookies-Knopf, Kaufleiste, Warenkorb-Leiste) werden ausgeblendet,
      damit sie Feld und Knopf nicht verdecken.
   G) Liegt die Newsletter-Leiste unten, bekommt <html> die Klasse
      zinke-nl-leiste-da; zinke-93.css hebt dann den Cookies-Knopf darueber
      (vorher lag er mit z-index 59 auf der Leiste mit z-index 54).

   Muss VOR assets/zinke-newsletter.js laufen (beide defer, Reihenfolge im
   Dokument), weil zinke-newsletter.js beim Start liest, ob das Pop-up mit
   Fehler aufgehen soll ([data-zinke-nl-fehlerhaft]).
*/
(function () {
  'use strict';
  if (window.__zinkeFormschutz) return;
  window.__zinkeFormschutz = true;

  var K_LETZTER = 'zinkeFormLetzter';

  /* ---------- Texte, 9 Sprachen ---------- */
  var TEXTE = {
    de: {
      leer: 'Bitte gib deine E-Mail-Adresse ein.',
      at: 'Da fehlt das @ – zum Beispiel name@gmail.com.',
      endung: 'Da fehlt die Endung nach dem Punkt – zum Beispiel @gmail.com oder @web.de.',
      zeichen: 'Die Adresse enthält ein Zeichen, das in E-Mail-Adressen nicht geht (zum Beispiel ä, ö, ü oder ß). Bitte ae, oe, ue oder ss schreiben.',
      format: 'Das sieht noch nicht nach einer vollständigen E-Mail-Adresse aus. Bitte prüf die Schreibweise, zum Beispiel name@gmail.com.',
      tipp: 'Meintest du {v}?',
      uebernehmen: 'Übernehmen',
      wegwerf: 'Bitte eine dauerhafte E-Mail-Adresse verwenden, keine Wegwerf- oder Beispieladresse.',
      server: 'Diese Adresse wurde nicht angenommen. Bitte prüf die Schreibweise und tipp noch einmal auf den Knopf.'
    },
    en: {
      leer: 'Please enter your email address.',
      at: 'The @ is missing – for example name@gmail.com.',
      endung: 'The ending after the dot is missing – for example @gmail.com or @outlook.com.',
      zeichen: 'The address contains a character that email addresses cannot use (for example ä, ö, ü or ß).',
      format: 'That does not look like a complete email address yet. Please check the spelling, for example name@gmail.com.',
      tipp: 'Did you mean {v}?',
      uebernehmen: 'Use this',
      wegwerf: 'Please use a permanent email address, not a disposable or example one.',
      server: 'This address was not accepted. Please check the spelling and tap the button again.'
    },
    nl: {
      leer: 'Vul je e-mailadres in.',
      at: 'Het @ ontbreekt – bijvoorbeeld naam@gmail.com.',
      endung: 'De extensie na de punt ontbreekt – bijvoorbeeld @gmail.com of @hotmail.nl.',
      zeichen: 'Het adres bevat een teken dat niet in e-mailadressen mag (bijvoorbeeld ä, ö, ü of ß).',
      format: 'Dit lijkt nog geen volledig e-mailadres. Controleer de spelling, bijvoorbeeld naam@gmail.com.',
      tipp: 'Bedoelde je {v}?',
      uebernehmen: 'Overnemen',
      wegwerf: 'Gebruik een blijvend e-mailadres, geen wegwerp- of voorbeeldadres.',
      server: 'Dit adres werd niet geaccepteerd. Controleer de spelling en tik nog een keer op de knop.'
    },
    fr: {
      leer: 'Veuillez saisir votre adresse e-mail.',
      at: 'Il manque le @ – par exemple nom@gmail.com.',
      endung: 'Il manque l’extension après le point – par exemple @gmail.com ou @orange.fr.',
      zeichen: 'L’adresse contient un caractère interdit dans les adresses e-mail (par exemple ä, ö, ü ou ß).',
      format: 'Cela ne ressemble pas encore à une adresse e-mail complète. Vérifiez l’orthographe, par exemple nom@gmail.com.',
      tipp: 'Vouliez-vous dire {v} ?',
      uebernehmen: 'Utiliser',
      wegwerf: 'Merci d’utiliser une adresse e-mail permanente, pas une adresse jetable ou d’exemple.',
      server: 'Cette adresse n’a pas été acceptée. Vérifiez l’orthographe et appuyez de nouveau sur le bouton.'
    },
    es: {
      leer: 'Introduce tu dirección de correo.',
      at: 'Falta la @ – por ejemplo nombre@gmail.com.',
      endung: 'Falta la terminación después del punto – por ejemplo @gmail.com o @hotmail.es.',
      zeichen: 'La dirección contiene un carácter que no se admite en correos (por ejemplo ä, ö, ü o ß).',
      format: 'Todavía no parece una dirección de correo completa. Revisa cómo está escrita, por ejemplo nombre@gmail.com.',
      tipp: '¿Quisiste decir {v}?',
      uebernehmen: 'Usar',
      wegwerf: 'Usa una dirección de correo permanente, no una desechable ni de ejemplo.',
      server: 'Esta dirección no fue aceptada. Revisa cómo está escrita y vuelve a pulsar el botón.'
    },
    da: {
      leer: 'Skriv din e-mailadresse.',
      at: 'Der mangler et @ – for eksempel navn@gmail.com.',
      endung: 'Der mangler endelsen efter punktummet – for eksempel @gmail.com eller @hotmail.dk.',
      zeichen: 'Adressen indeholder et tegn, som ikke kan bruges i e-mailadresser (for eksempel ä, ö, ü eller ß).',
      format: 'Det ligner endnu ikke en fuld e-mailadresse. Tjek stavemåden, for eksempel navn@gmail.com.',
      tipp: 'Mente du {v}?',
      uebernehmen: 'Brug denne',
      wegwerf: 'Brug en fast e-mailadresse, ikke en engangs- eller eksempeladresse.',
      server: 'Adressen blev ikke godkendt. Tjek stavemåden, og tryk på knappen igen.'
    },
    nb: {
      leer: 'Skriv inn e-postadressen din.',
      at: 'Det mangler en @ – for eksempel navn@gmail.com.',
      endung: 'Endelsen etter punktumet mangler – for eksempel @gmail.com eller @hotmail.no.',
      zeichen: 'Adressen inneholder et tegn som ikke kan brukes i e-postadresser (for eksempel ä, ö, ü eller ß).',
      format: 'Dette ser ennå ikke ut som en fullstendig e-postadresse. Sjekk stavemåten, for eksempel navn@gmail.com.',
      tipp: 'Mente du {v}?',
      uebernehmen: 'Bruk denne',
      wegwerf: 'Bruk en fast e-postadresse, ikke en engangs- eller eksempeladresse.',
      server: 'Adressen ble ikke godtatt. Sjekk stavemåten og trykk på knappen igjen.'
    },
    sv: {
      leer: 'Fyll i din e-postadress.',
      at: 'Det saknas ett @ – till exempel namn@gmail.com.',
      endung: 'Ändelsen efter punkten saknas – till exempel @gmail.com eller @hotmail.se.',
      zeichen: 'Adressen innehåller ett tecken som inte fungerar i e-postadresser (till exempel ä, ö, ü eller ß).',
      format: 'Det ser ännu inte ut som en fullständig e-postadress. Kontrollera stavningen, till exempel namn@gmail.com.',
      tipp: 'Menade du {v}?',
      uebernehmen: 'Använd',
      wegwerf: 'Använd en permanent e-postadress, inte en engångs- eller exempeladress.',
      server: 'Adressen godkändes inte. Kontrollera stavningen och tryck på knappen igen.'
    },
    fi: {
      leer: 'Kirjoita sähköpostiosoitteesi.',
      at: '@-merkki puuttuu – esimerkiksi nimi@gmail.com.',
      endung: 'Pisteen jälkeinen pääte puuttuu – esimerkiksi @gmail.com tai @outlook.com.',
      zeichen: 'Osoitteessa on merkki, jota sähköpostiosoitteissa ei voi käyttää (esimerkiksi ä, ö, ü tai ß).',
      format: 'Tämä ei vielä näytä täydeltä sähköpostiosoitteelta. Tarkista kirjoitusasu, esimerkiksi nimi@gmail.com.',
      tipp: 'Tarkoititko {v}?',
      uebernehmen: 'Käytä',
      wegwerf: 'Käytä pysyvää sähköpostiosoitetta, ei kertakäyttöistä tai esimerkkiosoitetta.',
      server: 'Osoitetta ei hyväksytty. Tarkista kirjoitusasu ja paina painiketta uudelleen.'
    },
    pl: {
      leer: 'Wpisz swój adres e-mail.',
      at: 'Brakuje znaku @ – na przykład imie@gmail.com.',
      endung: 'Brakuje końcówki po kropce – na przykład @gmail.com lub @wp.pl.',
      zeichen: 'Adres zawiera znak, którego nie można używać w adresach e-mail (na przykład ä, ö, ü lub ß).',
      format: 'To jeszcze nie wygląda na pełny adres e-mail. Sprawdź pisownię, na przykład imie@gmail.com.',
      tipp: 'Czy chodziło o {v}?',
      uebernehmen: 'Użyj',
      wegwerf: 'Użyj stałego adresu e-mail, a nie jednorazowego lub przykładowego.',
      server: 'Ten adres nie został przyjęty. Sprawdź pisownię i naciśnij przycisk jeszcze raz.'
    }
  };
  var sprache = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var T = TEXTE[sprache] || TEXTE.de;

  /* ---------- Regeln (Obermenge von zinke-nl-fest.js und zinke-newsletter.js) ---------- */
  var WEGWERF = ['mailinator.com','yopmail.com','yopmail.fr','trashmail.com','trashmail.de','10minutemail.com','10minutemail.de','guerrillamail.com','guerrillamail.de','sharklasers.com','temp-mail.org','tempmail.com','tempmailo.com','throwawaymail.com','getnada.com','dispostable.com','fakeinbox.com','maildrop.cc','mailnesia.com','spamgourmet.com','wegwerfemail.de','byom.de','muellmail.com','einrot.com','tempr.email','emailondeck.com','moakt.com','mohmal.com','luxusmail.org','inboxkitten.com','mail.tm','1secmail.com','minuteinbox.com','discard.email','tempmail.net','mailsac.com','trashmail.net','spam4.me'];
  var BEISPIEL = ['example.com','example.org','example.net','example.edu','example.de','beispiel.de','beispiel.com','test.de','test.com','testmail.de','muster.de','mustermann.de','musterfirma.de','domain.com','asdf.de','asdf.com','aaa.de','abc.de','xxx.de'];
  var BEISPIEL_TLD = ['test','invalid','local','localhost','example','internal','lan'];
  var FANTASIE = /^(max[._-]?mustermann|erika[._-]?mustermann|mustermann|maxmuster|john[._-]?doe|jane[._-]?doe|test\d*|testtest|test[._-]?mail|asdf+|qwert\w*|abcdef?|aaa+|xxx+|fake|dummy|kein[._-]?name|nobody|niemand)$/;

  // Haeufige Vertipper. Schluessel = getippte Domain, Wert = Vorschlag.
  var TIPPFEHLER = {
    'gmial.com':'gmail.com','gmai.com':'gmail.com','gmail.co':'gmail.com','gmail.con':'gmail.com','gmail.cm':'gmail.com','gmail.om':'gmail.com',
    'gmaill.com':'gmail.com','gamil.com':'gmail.com','gnail.com':'gmail.com','gmal.com':'gmail.com','gmail.c':'gmail.com','gmailcom':'gmail.com',
    'googlemail.co':'googlemail.com','googlemail.con':'googlemail.com',
    'gmx.d':'gmx.de','gmx.dee':'gmx.de','gmxde':'gmx.de','gmx.ed':'gmx.de','gmxx.de':'gmx.de','gmx.nett':'gmx.net',
    'web.d':'web.de','webb.de':'web.de','wbe.de':'web.de','web.dee':'web.de','webde':'web.de','web.ed':'web.de','we.de':'web.de',
    'hotmai.com':'hotmail.com','hotmial.com':'hotmail.com','hotmail.co':'hotmail.com','hotmail.con':'hotmail.com','hotmal.com':'hotmail.com',
    'outlok.com':'outlook.com','outlook.co':'outlook.com','outlook.con':'outlook.com','outloo.com':'outlook.com','otlook.com':'outlook.com',
    'yaho.de':'yahoo.de','yahoo.d':'yahoo.de','yahho.de':'yahoo.de','yaho.com':'yahoo.com','yahoo.co':'yahoo.com','yahoo.con':'yahoo.com',
    't-onlin.de':'t-online.de','tonline.de':'t-online.de','t-online.d':'t-online.de','t-onine.de':'t-online.de','t-online.com':'t-online.de',
    'icloud.de':'icloud.com','icloud.co':'icloud.com','icloud.con':'icloud.com','icoud.com':'icloud.com','iclod.com':'icloud.com','icould.com':'icloud.com',
    'freenet.d':'freenet.de','freent.de':'freenet.de','aol.de.':'aol.de','aol.co':'aol.com','aol.con':'aol.com','online.d':'online.de','mail.d':'mail.de'
  };

  function bereinigen(wert) {
    var v = String(wert || '').replace(/＠/g, '@').replace(/\s+/g, '');
    var i = v.lastIndexOf('@');
    if (i < 0) return v;
    var lokal = v.slice(0, i);
    var domain = v.slice(i + 1).toLowerCase().replace(/,/g, '.').replace(/\.+$/, '').replace(/^\.+/, '');
    return lokal + '@' + domain;
  }

  /* Rueckgabe: '' = in Ordnung, sonst {text, vorschlag} */
  function pruefen(v) {
    if (!v) return { text: T.leer };
    if (v.indexOf('@') < 0) return { text: T.at };
    if (/[^\x21-\x7e]/.test(v)) return { text: T.zeichen };
    var teile = v.split('@');
    if (teile.length !== 2 || !teile[0] || !teile[1]) return { text: T.format };
    var lokal = teile[0], domain = teile[1];
    if (TIPPFEHLER[domain]) {
      return { text: T.tipp.replace('{v}', lokal + '@' + TIPPFEHLER[domain]), vorschlag: lokal + '@' + TIPPFEHLER[domain] };
    }
    if (domain.indexOf('.') < 0) return { text: T.endung };
    var tld = domain.split('.').pop();
    if (tld.length < 2 || /[^a-z]/.test(tld)) return { text: T.endung };
    if (v.length < 6 || v.length > 254 || lokal.length < 2 || lokal.length > 64) return { text: T.format };
    if (!/^[A-Za-z0-9.!#$%&'*+\/=?^_`{|}~-]+$/.test(lokal)) return { text: T.format };
    if (/^\.|\.$|\.\./.test(lokal)) return { text: T.format };
    if (!/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/.test(domain)) return { text: T.format };
    if (BEISPIEL_TLD.indexOf(tld) > -1 || BEISPIEL.indexOf(domain) > -1 || /^example\./.test(domain) ||
        WEGWERF.indexOf(domain) > -1 || FANTASIE.test(lokal.toLowerCase())) return { text: T.wegwerf };
    return '';
  }

  /* ---------- Welche Formulare ---------- */
  function istEmailFormular(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var a = form.getAttribute('action') || '';
    if (a.indexOf('/contact') < 0) return false;
    return !!form.querySelector('input[name="contact[email]"]');
  }

  function feldVon(form) { return form.querySelector('input[name="contact[email]"]'); }

  /* Fehlerstelle im Formular: vorhandene Meldungsfelder zuerst, sonst eine eigene */
  function meldungsfeld(form) {
    var el = form.querySelector('[data-zinke-nl-fest-fehler], [data-zinke-nl-fehler], [data-zinke-formschutz-meldung]');
    if (el) return el;
    el = document.createElement('p');
    el.setAttribute('data-zinke-formschutz-meldung', '');
    el.setAttribute('role', 'alert');
    el.className = 'zinke-formschutz-meldung';
    var feld = feldVon(form);
    var zeile = feld && feld.parentElement && feld.parentElement !== form ? feld.parentElement : feld;
    if (zeile && zeile.parentNode) zeile.parentNode.insertBefore(el, zeile.nextSibling);
    else form.appendChild(el);
    return el;
  }

  function zeigen(form, befund) {
    var el = meldungsfeld(form);
    el.textContent = befund.text;
    if (befund.vorschlag) {
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'zinke-formschutz-vorschlag';
      knopf.textContent = T.uebernehmen;
      knopf.addEventListener('click', function () {
        var feld = feldVon(form);
        if (feld) { feld.value = befund.vorschlag; feld.focus(); }
        el.hidden = true;
      });
      el.appendChild(document.createTextNode(' '));
      el.appendChild(knopf);
    }
    el.hidden = false;
    // Liquid-Fehlerzeile vom letzten Versuch ausblenden, damit nichts doppelt steht
    Array.prototype.forEach.call(form.querySelectorAll('[data-zinke-liquid-fehler]'), function (x) { x.hidden = true; });
    var feld = feldVon(form);
    if (feld) feld.setAttribute('aria-invalid', 'true');
    var knopfSenden = form.querySelector('[aria-busy]');
    if (knopfSenden) knopfSenden.removeAttribute('aria-busy');
  }

  function verbergen(form) {
    var el = form.querySelector('[data-zinke-nl-fest-fehler], [data-zinke-nl-fehler], [data-zinke-formschutz-meldung]');
    if (el) el.hidden = true;
    var feld = feldVon(form);
    if (feld) feld.removeAttribute('aria-invalid');
  }

  function speicher(art) { try { return window[art]; } catch (e) { return null; } }
  function merken(form, email) {
    var s = speicher('sessionStorage'); if (!s) return;
    try { s.setItem(K_LETZTER, JSON.stringify({ id: form.id || '', email: email, zeit: Date.now() })); } catch (e) {}
  }
  function letzter() {
    var s = speicher('sessionStorage'); if (!s) return null;
    try { var o = JSON.parse(s.getItem(K_LETZTER) || 'null'); if (o && Date.now() - o.zeit < 30 * 60000) return o; } catch (e) {}
    return null;
  }
  function vergessen() { var s = speicher('sessionStorage'); if (s) try { s.removeItem(K_LETZTER); } catch (e) {} }

  /* ---------- A) Absenden abfangen, CAPTURE-Phase ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!istEmailFormular(form)) return;
    var feld = feldVon(form);
    if (!feld) return;
    var sauber = bereinigen(feld.value);
    if (sauber !== feld.value) feld.value = sauber;
    var befund = pruefen(sauber);
    if (befund) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Shopifys form-persister und alle anderen Listener sehen das Absenden nicht
      zeigen(form, befund);
      try { feld.focus({ preventScroll: true }); } catch (x) { feld.focus(); }
      return;
    }
    verbergen(form);
    merken(form, sauber);
  }, true);

  /* Beim Tippen die Meldung wegnehmen */
  document.addEventListener('input', function (e) {
    var feld = e.target;
    if (!feld || feld.name !== 'contact[email]' || !feld.form || !istEmailFormular(feld.form)) return;
    var el = feld.form.querySelector('[data-zinke-formschutz-meldung]');
    if (el) el.hidden = true;
    feld.removeAttribute('aria-invalid');
  }, true);

  /* ---------- D) novalidate: unsere Meldung statt Browser-Sprechblase ---------- */
  /* Nur Formulare, deren einziges Pflichtfeld die Adresse ist (Newsletter,
     Warteliste). Das Kontaktformular behaelt die Browser-Pruefung, weil dort
     auch Name und Nachricht Pflicht sind. */
  function nurEmail(f) {
    var pflicht = f.querySelectorAll('[required]');
    for (var i = 0; i < pflicht.length; i++) if (pflicht[i].name !== 'contact[email]') return false;
    return true;
  }
  function abschalten(f) { if (istEmailFormular(f) && nurEmail(f)) f.noValidate = true; }
  function ohneBrowserpruefung(wurzel) {
    var forms = (wurzel || document).querySelectorAll ? (wurzel || document).querySelectorAll('form') : [];
    Array.prototype.forEach.call(forms, abschalten);
  }
  ohneBrowserpruefung(document);
  if (window.MutationObserver) {
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var n = liste[i].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].nodeType !== 1) continue;
          if (n[j].tagName === 'FORM') abschalten(n[j]);
          else if (n[j].querySelector && n[j].querySelector('form')) ohneBrowserpruefung(n[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- E) Rueckweg nach Ablehnung durch Shopify ---------- */
  function rueckweg() {
    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return; }
    var ok = p.get('customer_posted') === 'true' || p.get('contact_posted') === 'true';
    if (ok) {
      vergessen();
      // Erfolg: Shopify meldet posted_successfully an ALLE Kundenformulare der
      // Seite. Bis 9.2 ging deshalb nach einer Fuss- oder Wartelisten-Anmeldung
      // zusaetzlich das Pop-up mit seinem Dankschritt auf. Das Pop-up soll nur
      // danken, wenn es selbst abgeschickt wurde (Anker #ZinkeNewsletter).
      var a = (location.hash || '').replace('#', '');
      var pop = document.getElementById('ZinkeNewsletter');
      if (pop && a && a !== 'ZinkeNewsletter') {
        Array.prototype.forEach.call(pop.querySelectorAll('[data-zinke-nl-erfolg]'), function (x) { x.remove(); });
      }
      return;
    }
    var typ = p.get('form_type');
    if (!typ) return;
    var alt = letzter();
    if (typ !== 'customer') return; // Kontaktformular: Shopify zeigt seine eigenen Fehler (Name, Nachricht, Adresse)

    var tags = p.get('contact[tags]') || '';
    var anker = (location.hash || '').replace('#', '');
    var ziel = anker ? document.getElementById(anker) : null;
    if (!ziel || ziel.tagName !== 'FORM') {
      if (/popup-/.test(tags)) ziel = document.getElementById('ZinkeNewsletter');
      else if (/fest-seite/.test(tags)) ziel = document.getElementById('ZinkeNlFest-seite');
      else if (/fest-fuss/.test(tags)) ziel = document.getElementById('ZinkeNlFest-fuss');
      else if (alt && alt.id) ziel = document.getElementById(alt.id);
    }

    // Pop-up-Fehlerflag nur, wenn wirklich das Pop-up gescheitert ist.
    var popup = document.getElementById('ZinkeNewsletter');
    if (popup && ziel !== popup) {
      Array.prototype.forEach.call(popup.querySelectorAll('[data-zinke-nl-fehlerhaft]'), function (x) { x.remove(); });
    }
    // Liquid-Fehlerzeilen in anderen Formularen entfernen
    Array.prototype.forEach.call(document.querySelectorAll('[data-zinke-liquid-fehler]'), function (x) {
      if (!ziel || !ziel.contains(x)) x.hidden = true;
    });

    if (ziel && istEmailFormular(ziel)) {
      var feld = feldVon(ziel);
      if (feld && alt && alt.email && (!alt.id || alt.id === ziel.id)) feld.value = alt.email;
      zeigen(ziel, { text: T.server });
      if (ziel === popup) {
        // zinke-newsletter.js oeffnet das Pop-up beim Start, wenn dieses Flag da ist
        if (!popup.querySelector('[data-zinke-nl-fehlerhaft]')) {
          var flag = document.createElement('span');
          flag.setAttribute('data-zinke-nl-fehlerhaft', '');
          flag.hidden = true;
          popup.appendChild(flag);
        }
      } else {
        var hin = function () { try { ziel.scrollIntoView({ block: 'center' }); } catch (x) { ziel.scrollIntoView(); } };
        if (document.readyState === 'complete') setTimeout(hin, 60); else window.addEventListener('load', function () { setTimeout(hin, 60); });
      }
    }

    // URL bereinigen: Formularreste raus, alles andere bleibt
    try {
      ['form_type', 'utf8', 'contact[tags]', 'contact[email]', 'contact[name]', 'contact[body]', 'form_key'].forEach(function (k) { p.delete(k); });
      var rest = p.toString();
      history.replaceState(history.state, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
    } catch (e) {}
  }
  rueckweg();

  /* ---------- F) Tastatur offen: feste Leisten weg (nur Handy) ---------- */
  var handy = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function eingabe(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return true;
    if (el.tagName !== 'INPUT') return false;
    return !/^(button|submit|checkbox|radio|range|color|file|image|reset|hidden)$/i.test(el.type || 'text');
  }
  document.addEventListener('focusin', function (e) {
    if (handy && handy.matches && eingabe(e.target)) document.documentElement.classList.add('zinke-tippt');
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!eingabe(document.activeElement)) document.documentElement.classList.remove('zinke-tippt');
    }, 120);
  });

  /* ---------- G) Newsletter-Leiste da? ---------- */
  function leisteDa() {
    var l = document.querySelector('.zinke-nl-leiste');
    document.documentElement.classList.toggle('zinke-nl-leiste-da', !!l);
  }
  if (window.MutationObserver) {
    var start = function () {
      leisteDa();
      new MutationObserver(leisteDa).observe(document.body, { childList: true });
    };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
})();